// Librerias
import React from 'react'
import { AutoSizer, Table, Column } from 'react-virtualized'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './modal.css'
let cx = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}

export class ModalEditarUsuario extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            zona: this.props.zona,
            captador: this.props.captador,
            error: {},
            valorZona: this.props.valorZona
        }
        this.onPrecioChange = (key, evt)=>{
            this.setState({valorZona: evt.target.value})
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({error: {}}, ()=>{
                this.props.actualizarValor(this.state.zona, this.state.valorZona)
                    .then(()=>{
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        this.setState({error: error.data})
                    })
            })
        }
    }
    componentWillMount(){
        
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Body>
                    <form className="form-horizontal" onSubmit={this.handleSubmit}>
                        <h4>Indíque el nuevo valor</h4>
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Valor Actual</label>
                            <div className="col-sm-3">
                                <input type="number" className="form-control" value={this.state.valorZona}
                                       onChange={this.onPrecioChange.bind(this, 'valorZona')}/>
                            </div>
                        </div>

                        <div className={cx('editarUsuario_footer')}>
                            <a href="#" className={cx("btn btn-block btn-default", 'btn-50-perc')} onClick={this.props.hideModal}>Cancelar</a>
                            <button type="submit" className={cx("btn btn-block btn-primary", 'btn-50-perc')}>Modificar</button>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>
        )
    }
}
export const ModalEliminarZona = ({hideModal, onBloquear})=>
    <Modal show={true} onHide={hideModal} className={cx('modal')}>
        <Modal.Header closeButton>
            <Modal.Title>¿Esta seguro que desea eliminar la relación con esta zona?</Modal.Title>
        </Modal.Header>
        <Modal.Footer className={cx('bloquearUsuario_footer')} >
            <button className="btn btn-block btn-default" onClick={hideModal}>Cancelar</button>
            <button className="btn btn-block btn-danger" onClick={onBloquear}>Eliminar Relación</button>
        </Modal.Footer>
    </Modal>


// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorCaptadoresZonas/Modales.jsx